import React, { FC, memo, useEffect, useRef, useState } from 'react'

import { getUnixNowTime } from '@sportworld/js-sdk/src/utils/utils'

import { TileProgressElem, TileProgressValue } from './styles'

const TileProgressRaw: FC<{
  start: number | undefined
  end: number | undefined
  isBottomPosition: boolean
}> = ({ start = 0, end = 0, isBottomPosition = false }) => {
  const [viewed, setViewed] = useState<number>(0)
  const interval = useRef(0)

  const duration = end - start
  const updateSteps = 50
  const updateInterval = duration / updateSteps

  const updatePosition = () => {
    const now = getUnixNowTime()
    const position = now - start
    if (position <= duration) {
      const viewed = (position / duration) * 100
      setViewed(viewed)
    } else {
      clearInterval(interval.current)
    }
  }

  useEffect(() => {
    if (duration <= 0) {
      return
    }

    updatePosition()
    interval.current = window.setInterval(() => {
      updatePosition()
    }, updateInterval * 1000)

    return () => {
      clearInterval(interval.current)
    }
  }, [])

  return (
    <TileProgressElem $isBottomPosition={isBottomPosition}>
      <TileProgressValue $viewed={viewed} />
    </TileProgressElem>
  )
}

export const TileProgress = memo(TileProgressRaw)
